"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ClientMetricReportDirection_1 = require("../clientmetricreport/ClientMetricReportDirection");

var ClientMetricReportMediaType_1 = require("../clientmetricreport/ClientMetricReportMediaType");

var ClientVideoStreamReceivingReport_1 = require("../clientmetricreport/ClientVideoStreamReceivingReport");

var ReconnectionHealthPolicy_1 = require("../connectionhealthpolicy/ReconnectionHealthPolicy");

var UnusableAudioWarningConnectionHealthPolicy_1 = require("../connectionhealthpolicy/UnusableAudioWarningConnectionHealthPolicy");

var MeetingSessionStatus_1 = require("../meetingsession/MeetingSessionStatus");

var MeetingSessionStatusCode_1 = require("../meetingsession/MeetingSessionStatusCode");

var SignalingClientEventType_1 = require("../signalingclient/SignalingClientEventType");

var AudioLogEvent_1 = require("../statscollector/AudioLogEvent");

var VideoLogEvent_1 = require("../statscollector/VideoLogEvent");

var Types_1 = require("../utils/Types");

var BaseTask_1 = require("./BaseTask");
/*
 * [[MonitorTask]] monitors connections using SignalingAndMetricsConnectionMonitor.
 */


var MonitorTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(MonitorTask, _BaseTask_1$default);

  var _super = _createSuper(MonitorTask);

  function MonitorTask(context, connectionHealthPolicyConfiguration, initialConnectionHealthData) {
    var _this;

    _classCallCheck(this, MonitorTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.initialConnectionHealthData = initialConnectionHealthData;
    _this.taskName = 'MonitorTask';
    _this.prevSignalStrength = 1;
    _this.currentVideoDownlinkBandwidthEstimationKbps = 10000;
    _this.currentAvailableStreamAvgBitrates = null;
    _this.hasSignalingError = false;
    _this.presenceHandlerCalled = false; // See comment above invocation of `pauseResubscribeCheck` in `DefaultAudioVideoController`
    // for explanation.

    _this.isResubscribeCheckPaused = false;
    _this.pendingMetricsReport = undefined;

    _this.checkAndSendWeakSignalEvent = function (signalStrength) {
      var isCurrentSignalBad = signalStrength < 1;
      var isPrevSignalBad = _this.prevSignalStrength < 1;
      var signalStrengthEventType = isCurrentSignalBad ? !isPrevSignalBad ? AudioLogEvent_1.default.RedmicStartLoss : null : isPrevSignalBad ? AudioLogEvent_1.default.RedmicEndLoss : null;

      if (signalStrengthEventType) {
        _this.context.statsCollector.logAudioEvent(signalStrengthEventType);
      }

      _this.prevSignalStrength = signalStrength;
    };

    _this.realtimeFatalErrorCallback = function (error) {
      _this.logger.error("realtime error: ".concat(error, ": ").concat(error.stack));

      _this.context.audioVideoController.handleMeetingSessionStatus(new MeetingSessionStatus_1.default(MeetingSessionStatusCode_1.default.RealtimeApiFailed), error);
    };

    _this.realtimeAttendeeIdPresenceHandler = function (presentAttendeeId, present) {
      var attendeeId = _this.context.meetingSessionConfiguration.credentials.attendeeId;

      _this.logger.info("attendeePresenceReceived: ".concat(attendeeId));

      if (attendeeId === presentAttendeeId && present && !_this.presenceHandlerCalled) {
        _this.presenceHandlerCalled = true;
        _this.context.attendeePresenceDurationMs = Date.now() - _this.context.startAudioVideoTimestamp;
        /* istanbul ignore else */

        if (_this.context.eventController) {
          _this.context.eventController.publishEvent('attendeePresenceReceived', {
            attendeePresenceDurationMs: _this.context.attendeePresenceDurationMs
          });
        }
      }
    };

    _this.generateAudioVideoEventAttributes = function () {
      var _this$context = _this.context,
          signalingOpenDurationMs = _this$context.signalingOpenDurationMs,
          poorConnectionCount = _this$context.poorConnectionCount,
          startTimeMs = _this$context.startTimeMs,
          iceGatheringDurationMs = _this$context.iceGatheringDurationMs,
          attendeePresenceDurationMs = _this$context.attendeePresenceDurationMs,
          meetingStartDurationMs = _this$context.meetingStartDurationMs;
      var attributes = {
        maxVideoTileCount: _this.context.maxVideoTileCount,
        meetingDurationMs: startTimeMs === null ? 0 : Math.round(Date.now() - startTimeMs),
        signalingOpenDurationMs: signalingOpenDurationMs,
        iceGatheringDurationMs: iceGatheringDurationMs,
        attendeePresenceDurationMs: attendeePresenceDurationMs,
        poorConnectionCount: poorConnectionCount,
        meetingStartDurationMs: meetingStartDurationMs
      };
      return attributes;
    };

    _this.reconnectionHealthPolicy = new ReconnectionHealthPolicy_1.default(context.logger, Object.assign({}, connectionHealthPolicyConfiguration), _this.initialConnectionHealthData.clone());
    _this.unusableAudioWarningHealthPolicy = new UnusableAudioWarningConnectionHealthPolicy_1.default(Object.assign({}, connectionHealthPolicyConfiguration), _this.initialConnectionHealthData.clone());
    return _this;
  }

  _createClass(MonitorTask, [{
    key: "removeObserver",
    value: function removeObserver() {
      this.context.audioVideoController.removeObserver(this);
      this.context.realtimeController.realtimeUnsubscribeToFatalError(this.realtimeFatalErrorCallback);
      this.context.realtimeController.realtimeUnsubscribeToLocalSignalStrengthChange(this.checkAndSendWeakSignalEvent);
      this.context.realtimeController.realtimeUnsubscribeToAttendeeIdPresence(this.realtimeAttendeeIdPresenceHandler);
      this.context.signalingClient.removeObserver(this);
    }
  }, {
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.context.removableObservers.push(this);
                this.context.audioVideoController.addObserver(this);
                this.context.realtimeController.realtimeSubscribeToFatalError(this.realtimeFatalErrorCallback);
                this.context.realtimeController.realtimeSubscribeToLocalSignalStrengthChange(this.checkAndSendWeakSignalEvent);
                this.context.realtimeController.realtimeSubscribeToAttendeeIdPresence(this.realtimeAttendeeIdPresenceHandler);
                this.context.connectionMonitor.start();
                this.context.statsCollector.start(this.context.signalingClient, this.context.videoStreamIndex);
                this.context.signalingClient.registerObserver(this);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "pauseResubscribeCheck",
    value: function pauseResubscribeCheck() {
      this.isResubscribeCheckPaused = true;
    }
  }, {
    key: "resumeResubscribeCheck",
    value: function resumeResubscribeCheck() {
      if (!this.isResubscribeCheckPaused) {
        // Do not recheck subcribe if it wasn't paused to begin with.
        return;
      }

      this.isResubscribeCheckPaused = false;

      if (this.pendingMetricsReport) {
        this.context.logger.info('Resuming resubscribe check with pending metrics report');

        if (this.checkResubscribe(this.pendingMetricsReport)) {
          this.context.audioVideoController.update({
            needsRenegotiation: false
          });
        }
      }
    }
  }, {
    key: "videoTileDidUpdate",
    value: function videoTileDidUpdate(_tileState) {
      this.context.maxVideoTileCount = Math.max(this.context.maxVideoTileCount, this.context.videoTileController.getAllVideoTiles().length);
    }
  }, {
    key: "videoSendHealthDidChange",
    value: function videoSendHealthDidChange(bitrateKbps, packetsPerSecond) {
      if (this.context.videoInputAttachedTimestampMs === 0 || !this.context.videoTileController.hasStartedLocalVideoTile() || !this.context.lastKnownVideoAvailability.canStartLocalVideo) {
        return;
      }

      var tracks = this.context.activeVideoInput !== null ? this.context.activeVideoInput.getTracks() : null;

      if (!tracks || !tracks[0]) {
        return;
      }

      var durationMs = Date.now() - this.context.videoInputAttachedTimestampMs;

      if (packetsPerSecond > 0 || bitrateKbps > 0) {
        this.context.statsCollector.logVideoEvent(VideoLogEvent_1.default.SendingSuccess, this.context.videoDeviceInformation);
        this.context.statsCollector.logLatency('video_start_sending', durationMs, this.context.videoDeviceInformation);
        this.context.videoInputAttachedTimestampMs = 0;
      } else if (durationMs > MonitorTask.DEFAULT_TIMEOUT_FOR_START_SENDING_VIDEO_MS) {
        this.context.statsCollector.logVideoEvent(VideoLogEvent_1.default.SendingFailed, this.context.videoDeviceInformation);
        this.context.videoInputAttachedTimestampMs = 0;
      }
    }
  }, {
    key: "videoReceiveBandwidthDidChange",
    value: function videoReceiveBandwidthDidChange(newBandwidthKbps, oldBandwidthKbps) {
      this.logger.debug(function () {
        return "receiving bandwidth changed from prev=".concat(oldBandwidthKbps, " Kbps to curr=").concat(newBandwidthKbps, " Kbps");
      });
      this.currentVideoDownlinkBandwidthEstimationKbps = newBandwidthKbps;
    }
  }, {
    key: "checkResubscribe",
    value: function checkResubscribe(clientMetricReport) {
      if (this.isResubscribeCheckPaused) {
        this.context.logger.info('Resubscribe check is paused, setting incoming client metric report as pending');
        this.pendingMetricsReport = clientMetricReport;
        return;
      } else {
        this.pendingMetricsReport = undefined;
      }

      var metricReport = clientMetricReport.getObservableMetrics();

      if (!metricReport) {
        return false;
      }

      var availableSendBandwidth = metricReport.availableSendBandwidth || metricReport.availableOutgoingBitrate;
      var nackCountPerSecond = metricReport.nackCountReceivedPerSecond || metricReport.googNackCountReceivedPerSecond;
      var needResubscribe = false;
      this.context.videoDownlinkBandwidthPolicy.updateMetrics(clientMetricReport);
      var resubscribeForDownlink = this.context.videoDownlinkBandwidthPolicy.wantsResubscribe();
      needResubscribe = needResubscribe || resubscribeForDownlink;

      if (resubscribeForDownlink) {
        this.context.videosToReceive = this.context.videoDownlinkBandwidthPolicy.chooseSubscriptions();
        this.logger.info("trigger resubscribe for down=".concat(resubscribeForDownlink, "; videosToReceive=[").concat(this.context.videosToReceive.array(), "]"));
      }

      if (this.context.videoTileController.hasStartedLocalVideoTile()) {
        this.context.videoUplinkBandwidthPolicy.updateConnectionMetric({
          uplinkKbps: availableSendBandwidth / 1000,
          nackCountPerSecond: nackCountPerSecond
        });
        var resubscribeForUplink = this.context.videoUplinkBandwidthPolicy.wantsResubscribe();
        needResubscribe = needResubscribe || resubscribeForUplink;

        if (resubscribeForUplink) {
          this.logger.info("trigger resubscribe for up=".concat(resubscribeForUplink, "; videosToReceive=[").concat(this.context.videosToReceive.array(), "]"));
          this.context.videoUplinkBandwidthPolicy.chooseEncodingParameters();
          this.context.videoUplinkBandwidthPolicy.chooseMediaTrackConstraints();
        }
      }

      return needResubscribe;
    }
  }, {
    key: "metricsDidReceive",
    value: function metricsDidReceive(clientMetricReport) {
      var defaultClientMetricReport = clientMetricReport;

      if (!defaultClientMetricReport) {
        return;
      }

      if (this.checkResubscribe(clientMetricReport)) {
        this.context.audioVideoController.update({
          needsRenegotiation: false
        });
      }

      if (!this.currentAvailableStreamAvgBitrates) {
        return;
      }

      var streamMetricReport = defaultClientMetricReport.streamMetricReports;

      if (!streamMetricReport) {
        return;
      }

      var downlinkVideoStream = new Map();
      var videoReceivingBitrateMap = new Map(); // TODO: move those logic to stats collector.

      for (var ssrc in streamMetricReport) {
        if (streamMetricReport[ssrc].mediaType === ClientMetricReportMediaType_1.default.VIDEO && streamMetricReport[ssrc].direction === ClientMetricReportDirection_1.default.DOWNSTREAM) {
          downlinkVideoStream.set(streamMetricReport[ssrc].streamId, streamMetricReport[ssrc]);
        }
      }

      var fireCallback = false;

      var _iterator = _createForOfIteratorHelper(this.currentAvailableStreamAvgBitrates.bitrates),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var bitrate = _step.value;

          if (downlinkVideoStream.has(bitrate.sourceStreamId)) {
            var report = downlinkVideoStream.get(bitrate.sourceStreamId);
            var attendeeId = this.context.videoStreamIndex.attendeeIdForStreamId(bitrate.sourceStreamId);

            if (!attendeeId) {
              continue;
            }

            var newReport = new ClientVideoStreamReceivingReport_1.default();
            var prevBytesReceived = report.previousMetrics['bytesReceived'];
            var currBytesReceived = report.currentMetrics['bytesReceived'];

            if (!prevBytesReceived || !currBytesReceived) {
              continue;
            }

            var receivedBitrate = (currBytesReceived - prevBytesReceived) * 8 / 1000;
            newReport.expectedAverageBitrateKbps = bitrate.avgBitrateBps / 1000;
            newReport.receivedAverageBitrateKbps = receivedBitrate;
            newReport.attendeeId = attendeeId;

            if (receivedBitrate < bitrate.avgBitrateBps / 1000 * MonitorTask.DEFAULT_DOWNLINK_CALLRATE_UNDERSHOOT_FACTOR) {
              fireCallback = true;
            }

            videoReceivingBitrateMap.set(attendeeId, newReport);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (fireCallback) {
        this.logger.debug(function () {
          return "Downlink video streams are not receiving enough data";
        });
        this.context.audioVideoController.forEachObserver(function (observer) {
          Types_1.Maybe.of(observer.videoNotReceivingEnoughData).map(function (f) {
            return f.bind(observer)(Array.from(videoReceivingBitrateMap.values()));
          });
        });
      }
    }
  }, {
    key: "connectionHealthDidChange",
    value: function connectionHealthDidChange(connectionHealthData) {
      var _a;

      if (connectionHealthData.consecutiveMissedPongs === 0) {
        if (this.context.reconnectController) {
          this.context.reconnectController.setLastActiveTimestampMs(Date.now());
        }
      }

      this.reconnectionHealthPolicy.update(connectionHealthData);
      var reconnectionValue = this.reconnectionHealthPolicy.healthIfChanged();

      if (reconnectionValue !== null) {
        this.logger.info("reconnection health is now: ".concat(reconnectionValue));

        if (reconnectionValue === 0) {
          this.context.audioVideoController.handleMeetingSessionStatus(new MeetingSessionStatus_1.default(MeetingSessionStatusCode_1.default.ConnectionHealthReconnect), null);
        }
      }

      this.unusableAudioWarningHealthPolicy.update(connectionHealthData);
      var unusableAudioWarningValue = this.unusableAudioWarningHealthPolicy.healthIfChanged();

      if (unusableAudioWarningValue !== null) {
        this.logger.info("unusable audio warning is now: ".concat(unusableAudioWarningValue));

        if (unusableAudioWarningValue === 0) {
          this.context.poorConnectionCount += 1;
          var attributes = this.generateAudioVideoEventAttributes();
          (_a = this.context.eventController) === null || _a === void 0 ? void 0 : _a.publishEvent('receivingAudioDropped', attributes);

          if (this.context.videoTileController.haveVideoTilesWithStreams()) {
            this.context.audioVideoController.forEachObserver(function (observer) {
              Types_1.Maybe.of(observer.connectionDidSuggestStopVideo).map(function (f) {
                return f.bind(observer)();
              });
            });
          } else {
            this.context.audioVideoController.forEachObserver(function (observer) {
              Types_1.Maybe.of(observer.connectionDidBecomePoor).map(function (f) {
                return f.bind(observer)();
              });
            });
          }
        } else {
          this.context.audioVideoController.forEachObserver(function (observer) {
            Types_1.Maybe.of(observer.connectionDidBecomeGood).map(function (f) {
              return f.bind(observer)();
            });
          });
        }
      }
    }
  }, {
    key: "handleBitrateFrame",
    value: function handleBitrateFrame(bitrates) {
      var _this2 = this;

      var requiredBandwidthKbps = 0;
      this.currentAvailableStreamAvgBitrates = bitrates;
      this.logger.debug(function () {
        return "simulcast: bitrates from server ".concat(JSON.stringify(bitrates));
      });

      var _iterator2 = _createForOfIteratorHelper(bitrates.bitrates),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var bitrate = _step2.value;

          if (this.context.videosToReceive.contain(bitrate.sourceStreamId)) {
            requiredBandwidthKbps += bitrate.avgBitrateBps;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      requiredBandwidthKbps /= 1000;

      if (this.currentVideoDownlinkBandwidthEstimationKbps * MonitorTask.DEFAULT_DOWNLINK_CALLRATE_OVERSHOOT_FACTOR < requiredBandwidthKbps) {
        this.logger.info("Downlink bandwidth pressure is high: estimated bandwidth ".concat(this.currentVideoDownlinkBandwidthEstimationKbps, "Kbps, required bandwidth ").concat(requiredBandwidthKbps, "Kbps"));
        this.context.audioVideoController.forEachObserver(function (observer) {
          Types_1.Maybe.of(observer.estimatedDownlinkBandwidthLessThanRequired).map(function (f) {
            return f.bind(observer)(_this2.currentVideoDownlinkBandwidthEstimationKbps, requiredBandwidthKbps);
          });
        });
      }
    }
  }, {
    key: "handleSignalingClientEvent",
    value: function handleSignalingClientEvent(event) {
      var _a; // Don't add two or more consecutive "signalingDropped" states.


      if (event.type === SignalingClientEventType_1.default.WebSocketClosed && (event.closeCode === 4410 || event.closeCode >= 4500 && event.closeCode < 4600) || event.type === SignalingClientEventType_1.default.WebSocketError || event.type === SignalingClientEventType_1.default.WebSocketFailed) {
        if (!this.hasSignalingError) {
          var attributes = this.generateAudioVideoEventAttributes();
          (_a = this.context.eventController) === null || _a === void 0 ? void 0 : _a.publishEvent('signalingDropped', attributes);
          this.hasSignalingError = true;
        }
      } else if (event.type === SignalingClientEventType_1.default.WebSocketOpen) {
        this.hasSignalingError = false;
      }

      if (event.type === SignalingClientEventType_1.default.ReceivedSignalFrame) {
        if (!!event.message.bitrates) {
          var bitrateFrame = event.message.bitrates;
          this.context.videoStreamIndex.integrateBitratesFrame(bitrateFrame);
          this.context.videoDownlinkBandwidthPolicy.updateIndex(this.context.videoStreamIndex);
          this.handleBitrateFrame(event.message.bitrates);
        }

        var status = MeetingSessionStatus_1.default.fromSignalFrame(event.message);

        if (status.statusCode() !== MeetingSessionStatusCode_1.default.OK) {
          this.context.audioVideoController.handleMeetingSessionStatus(status, null);
        }
      }
    }
  }]);

  return MonitorTask;
}(BaseTask_1.default);

exports.default = MonitorTask;
MonitorTask.DEFAULT_TIMEOUT_FOR_START_SENDING_VIDEO_MS = 30000;
MonitorTask.DEFAULT_DOWNLINK_CALLRATE_OVERSHOOT_FACTOR = 1.5;
MonitorTask.DEFAULT_DOWNLINK_CALLRATE_UNDERSHOOT_FACTOR = 0.5;